@use 'src/globals/main';

pn-card {
  position: relative;
  display: block;
}

pn-card .pn-card {
  position: relative;

  background-color: main.$white;
  color: main.$gray900;

  border-radius: 0.5em;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  box-shadow:
    0em 0.0625em 0.125em 0em rgba(20, 20, 20, 0.11),
    0em 0.1875em 0.4375em 0em rgba(0, 0, 0, 0.13);

  @include main.pn-focus-base;
  @include main.pn-transition('background-color, outline-color');

  &[data-link]:hover {
    background-color: main.$blue50;
  }

  &[data-link][data-focus] {
    @include main.pn-focus-visible;
  }

  /** If you use a `href`, hide the navigation slot. */
  &[data-link] .pn-card-navigation > [slot='navigation'] {
    display: none;
  }

  &[data-horizontal] {
    flex-direction: row;
    &[data-reverse] {
      flex-direction: row-reverse;
      .pn-card-picture {
        clip-path: ellipse(100% 175% at right center);
      }
    }
    .pn-card-content {
      flex: 1 1 50%;
    }
    .pn-card-image {
      flex: 1 1 50%;
      flex-direction: row;
    }

    .pn-card-picture {
      width: 100%;
      clip-path: ellipse(100% 175% at left center);
    }
  }

  &[data-reverse] {
    flex-direction: column-reverse;
    .pn-card-picture {
      clip-path: ellipse(175% 100% at bottom center);
    }
  }

  &-header {
    display: flex;
    flex-direction: column;
    gap: clamp(0.5em, 5vw, 0.75em);
  }

  &-label {
    font-size: clamp(1.125em, 5vw, 1.5em);
    font-weight: 700;
    margin: 0;
    &-overline {
      color: main.$gray700;
      font-size: 0.875em;
      font-weight: 400;
      margin: 0;
    }
  }

  &-link {
    display: inline-flex;
    align-items: center;
    gap: 0.25em;

    color: main.$blue700;
    text-decoration-color: transparent;
    -webkit-tap-highlight-color: transparent;

    @include main.pn-transition('color, text-decoration-color');

    &:hover {
      color: main.$blue900;
      text-decoration-color: main.$blue900;
      > pn-icon > .pn-icon-svg > path {
        fill: main.$blue900;
      }
    }

    &:focus {
      outline: 0;
      color: main.$blue900;
      text-decoration-color: main.$blue900;
      > pn-icon > .pn-icon-svg > path {
        fill: main.$blue900;
      }
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &-content {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    flex: 1;
    gap: clamp(0.5em, 5vw, 0.75em);
    padding: clamp(0.75em, 5vw, 1.5em) clamp(0.75em, 5vw, 1.5em);
  }

  &-section {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    color: main.$gray700;

    &-paragraph,
    p {
      margin: 0 0 0.25em;
      &:last-child {
        margin: 0em;
      }
    }
  }

  &-navigation {
    margin-top: auto;
    padding-top: clamp(0.5em, 5vw, 0.75em);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5em;

    > pn-button {
      flex: 1 1 12em;
    }

    &:empty {
      display: none;
    }
  }

  &-image {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  &-picture {
    margin: 0;
    padding: 0;
    display: block;
    overflow: hidden;
    clip-path: ellipse(175% 100% at top center);
    aspect-ratio: var(--pn-card-aspect-ratio);

    &:empty {
      display: none;
    }
    > *[slot='image'] {
      display: block;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  &-tags {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5em;

    &:empty {
      display: none;
    }
  }

  > {
    @include main.pn-ripple(main.$blue700);
  }
}
